import { getAddress } from '@ethersproject/address'
import { AddressZero } from '@ethersproject/constants'
import { Contract } from '@ethersproject/contracts'
import { JsonRpcProvider, JsonRpcSigner } from '@ethersproject/providers'
import { Token } from '@uniswap/sdk-core'
import { FeeAmount } from '@uniswap/v3-sdk'
import { ChainTokenMap } from 'lib/hooks/useTokenList/utils'
import {
  isEncodedLabelhash,
  isDecrypted,
  decodeLabelhash,
  encodeLabelhash,
  labelhash,
} from './labelhash'


// returns the checksummed address if the address is valid, otherwise returns false
export function getUrlParamParam(realPath: string): string {
  const urlString = window.location.pathname
  let tempParam = urlString.substring(urlString.indexOf('/') + 1)
  if (tempParam.indexOf('?') > 0) {
    tempParam = tempParam.substring(0, tempParam.indexOf('?'));
  }
  tempParam = tempParam.replaceAll(realPath + "/", "");
  return tempParam;
}

export function getUrlParams(): any {
// 解析哈希中的查询参数，例如 #/path?param1=value1&param2=value2
  const paramsObj = {};
  const hash = window.location.search
  const queryString = hash.split('?')[1];
  // 使用 URLSearchParams 解析查询参数
  if (queryString) {
    const urlParams = new URLSearchParams(queryString);
    for (let [key, value] of urlParams.entries()) {
      // @ts-ignore
      paramsObj[key] = value;
    }
  }
  return paramsObj;
}


export function isAddress(value: any): string | false {
  try {
    return getAddress(value)
  } catch {
    return false
  }
}

// shorten the checksummed version of the input address to have 0x + 4 characters at start and end
export function shortenAddress(address: string, chars = 4): string {
  if(!address){
    return '';
  }
  const parsed = isAddress(address)
  if (!parsed) {
    throw Error(`Invalid 'address' parameter '${address}'.`)
  }
  return `${parsed.substring(0, chars + 2)}...${parsed.substring(42 - chars)}`
}

// account is not optional
function getSigner(provider: JsonRpcProvider, account: string): JsonRpcSigner {
  return provider.getSigner(account).connectUnchecked()
}

// account is optional
export function getProviderOrSigner(provider: JsonRpcProvider, account?: string): JsonRpcProvider | JsonRpcSigner {
  return account ? getSigner(provider, account) : provider
}

// account is optional
export function getContract(address: string, ABI: any, provider: JsonRpcProvider, account?: string): Contract {
  if (!isAddress(address) || address === AddressZero) {
    throw Error(`Invalid 'address' parameter '${address}'.`)
  }

  return new Contract(address, ABI, getProviderOrSigner(provider, account) as any)
}

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

export function isTokenOnList(chainTokenMap: ChainTokenMap, token?: Token): boolean {
  return Boolean(token?.isToken && chainTokenMap[token.chainId]?.[token.address])
}

export function formattedFeeAmount(feeAmount: FeeAmount): number {
  return feeAmount / 10000
}

export function getLabelhash(label:string) {
  return labelhash(label)
}


